import {observer} from "mobx-react";

import "./App.scss"
import {tenantStore} from "../../store"


const TenantSelectApp = observer(function TenantSelectApp() {
    return <div className={'app-wrapper'}>
        <div
            className={'content-container'}
            style={{
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column'
            }}
        >
            {tenantStore.tenants.map((tenant: string) => {
                const cfg = tenantStore.getConfig(tenant)!!
                return <button
                    key={tenant}
                    style={{
                        marginBottom: '1em',
                        width: '12em'
                    }}
                    onClick={() => window.location.href = `${cfg.path}/dashboard`}
                    className={'button is-primary'}>{cfg.display}</button>
            })}
        </div>
    </div>
})

export {
    TenantSelectApp
}
